module.exports = __webpack_public_path__ + "media/images/pla/pla11-42bdd039f8484c4b3293dae025bce321.jpg";